import { Card, Col, Form, Input, Row, Space, Typography } from "antd";
import React, { useMemo, useCallback } from "react";
import { useTranslation, Trans } from "react-i18next";
const { Title } = Typography;

const Requester = ({ getChildData }) => {
  const { t, i18n } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };
  
  const validatePhone = useCallback((_, value) => {
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(t("common:please_enter_a_valid_phone_number"))
    );
  }, [t]);
  
  const validationRules = useMemo(() => ({
    firstName: [{ required: true, max: 50, message: t("patientDetailsFMLS:please_enter_first_name") }],
    lastName: [{ required: true, max: 50, message: t("patientDetailsFMLS:please_enter_last_name") }],
    email: [{ required: true, max: 100, message: t("patientDetailsFMLS:please_enter_email") }, { type: "email", message: t("patientDetailsFMLS:please_enter_valid_email") }],
    phone: [{ required: true, max: 20, message: t("patientDetailsFMLS:please_enter_phone_number") }, { validator: validatePhone }],
    address: [{ required: true, max: 150, message: t("patientDetailsFMLS:please_enter_address") }],
    city: [{ required: true, max: 50, message: t("patientDetailsFMLS:please_enter_city_name") }],
    state: [{ required: true, max: 50, message: t("patientDetailsFMLS:please_enter_state_name") }],
    zipCode: [{ max: 8, required: true, message: t("patientDetailsFMLS:please_enter_zip_code") }, { pattern: /^[0-9]+$/, message: t("patientDetailsFMLS:zip_code_must_be_numeric") }, { min: 5, message: t("patientDetailsFMLS:zip_code_must_be_at_least_5_digits_long") }]
  }), [t, validatePhone]);
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("patientDetailsFMLS:requester_information")}
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-1 md:px-6 mb-4">
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterFName")}
            name="rfirstname"
            label={t("patientDetailsFMLS:first_name")}
            rules={validationRules.firstName}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterLName")}
            name="rlastname"
            label={t("patientDetailsFMLS:last_name")}
            required
            rules={validationRules.lastName}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterEmail")}
            name="requesteremail"
            label={t("patientDetailsFMLS:email")}
            rules={validationRules.email}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterPhoneNumber")}
            name="requesterphone"
            label={t("patientDetailsFMLS:phone_number")}
            rules={validationRules.phone}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterAddLine1")}
            label={t("patientDetailsFMLS:address_line_1")}
            name="raddress1"
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            layout="vertical"
            name="raddress2"
            label={t("patientDetailsFMLS:address_line_2")}
            onChange={(e) => callparent(e.target.value, "RequesterAddLine2")}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterCity")}
            name="rcity"
            label={t("patientDetailsFMLS:city")}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterState")}
            name="rstate"
            label={t("patientDetailsFMLS:state")}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterZipCode")}
            name="rzipcode"
            label={t("patientDetailsFMLS:zip_code")}
          >
            <Input maxLength={8} />
          </Form.Item>
        </Col>
      </Row>

      <Space direction="horizontal" className="px-6">
        <i className="text-base notes-ilatic">
          <Trans
            i18nKey="patientDetailsFMLS:please_note_fee_message"
            components={{
              u: <u />,
            }}
          />
        </i>
      </Space>
    </Card>
  );
};

export default Requester;
